import React from 'react';
import PropTypes from 'prop-types';
import { getPhotoThumbUrl } from '../../../../utils/Generic';
import breakpoints from '../../../../../tailwind/breakpoints';

const getImgByBp = (img) => Object.values(breakpoints).map((bpSize) => getPhotoThumbUrl(img, parseInt(bpSize, 10)));

const Image = ({
  img, width, height, className, alt,
}) => {
  if (!img) {
    const altToSlug = alt ? alt.replace(/\s/g, '+') : '';
    // image fallback
    return (
            <img
                    className={className}
                    alt={alt}
                    src={`http://dummyimage.com/${width}x${height}/e6e6e6/ffffff&text=${altToSlug}`}/>
    );
  }
  return (
          <picture>
            {getImgByBp(img).map((el) => <source key={el} srcSet={el}/>)}
            <img className={className} src={getPhotoThumbUrl(img, width, height)} alt={alt}/>
          </picture>
  );
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

Image.defaultProps = {
  width: 1000,
  height: 0,
};
export default Image;
